import _objectSpread from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'explicit',
  channelInterpretation: 'speakers'
};
export var createMediaStreamAudioDestinationNodeConstructor = function createMediaStreamAudioDestinationNodeConstructor(audioNodeConstructor, createNativeMediaStreamAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(MediaStreamAudioDestinationNode, _audioNodeConstructor);
    function MediaStreamAudioDestinationNode(context, options) {
      var _this;
      _classCallCheck(this, MediaStreamAudioDestinationNode);
      var nativeContext = getNativeContext(context);
      // Bug #173: Safari allows to create a MediaStreamAudioDestinationNode with an OfflineAudioContext.
      if (isNativeOfflineAudioContext(nativeContext)) {
        throw new TypeError();
      }
      var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);
      var nativeMediaStreamAudioDestinationNode = createNativeMediaStreamAudioDestinationNode(nativeContext, mergedOptions);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaStreamAudioDestinationNode).call(this, context, false, nativeMediaStreamAudioDestinationNode, null));
      _this._nativeMediaStreamAudioDestinationNode = nativeMediaStreamAudioDestinationNode;
      return _this;
    }
    _createClass(MediaStreamAudioDestinationNode, [{
      key: "stream",
      get: function get() {
        return this._nativeMediaStreamAudioDestinationNode.stream;
      }
    }]);
    return MediaStreamAudioDestinationNode;
  }(audioNodeConstructor);
};